import { CSSProperties, useMemo } from 'react';
import { BsIcon } from './bs-icon.models';

export type BsSize = 'sm' | 'lg' | '2x' | '3x' | '4x';

interface IconProps {
    icon: BsIcon;
    size?: BsSize;
    title?: string;
    iconClassName?: string;
    iconStyles?: CSSProperties;
    className?: string;
    children?: React.ReactNode;
}

export const Icon = ({
    icon,
    size,
    title,
    children,
    iconClassName,
    iconStyles,
    className,
}: IconProps): React.ReactElement => {
    const combinedClassName = useMemo(() => {
        return `bi bi-${icon} ${size ? 'icon-' + size : ''} ${iconClassName || ''}`;
    }, [icon, iconClassName, size]);

    return (
        <>
            <i title={title} className={combinedClassName} style={iconStyles} />
            {children && (
                <span className={`ml-2 ${className || ''}`} title={title}>
                    {children}
                </span>
            )}
        </>
    );
};
